import { render, staticRenderFns } from "./GroupConfigure.vue?vue&type=template&id=60c23b94&scoped=true&"
import script from "./GroupConfigure.vue?vue&type=script&lang=ts&"
export * from "./GroupConfigure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c23b94",
  null
  
)

export default component.exports